import { SUBMISSION_TYPE_ENUM } from '@data-access/shared';
import { PickUpItem, PickUpYouResponse } from '../types';

/** Covers the Pick Up Where You Left Off scenarios from ERM-11872. */
export const PICK_UP_ITEMS: PickUpItem[] = [
  // Last edit was a questionnaire section; mid-progress.
  {
    workspace_id: 'b2c3d4e5-0001-4f5a-8b9c-d0e1f2a30001',
    workspace_name: 'Cardio Phase II Trial Submission',
    submission_id: 200000101,
    submission_type: SUBMISSION_TYPE_ENUM.newStudy,
    survey_id: '3f6ffd99-c0ec-5f99-9246-5a7acc03b101',
    section_id: 'PatientEligibility-1fa62a',
    resume_target: 'section',
    last_edited_dt: '2026-10-14T13:45:00.000000',
    sponsor_name: 'HeartBio Research Inc.',
    sponsor_protocol_id: 'HB-2024-001',
    study_name: 'Cardio Phase II Trial',
    sections_completed: 4,
    sections_total: 7,
  },
  // Last edit was a document upload; routes to the Documents tab.
  {
    workspace_id: 'b2c3d4e5-0002-4f5a-8b9c-d0e1f2a30002',
    workspace_name: 'NeuraTech Longitudinal Study Submission',
    submission_id: 200000102,
    submission_type: SUBMISSION_TYPE_ENUM.newSite,
    documents_required: true,
    survey_id: '3f6ffd99-c0ec-5f99-9246-5a7acc03b101',
    section_id: 'PatientEligibility-1fa62a',
    resume_target: 'documents',
    document_id: 'c3d4e5f6-0002-4f5a-8b9c-d0e1f2a30002',
    last_edited_dt: '2026-10-14T09:10:00.000000',
    sponsor_name: 'NeuraTech Labs',
    sponsor_protocol_id: 'NT-2023-014',
    study_name: 'NeuraTech Longitudinal Study',
    sections_completed: 6,
    sections_total: 6,
  },
  {
    workspace_id: 'b2c3d4e5-0003-4f5a-8b9c-d0e1f2a30003',
    workspace_name: 'Oncology Adaptive Trial Submission',
    submission_id: 200000103,
    submission_type: SUBMISSION_TYPE_ENUM.newStudyandSite,
    survey_id: '3f6ffd99-c0ec-5f99-9246-5a7acc03b101',
    section_id: 'PatientEligibility-1fa62a',
    resume_target: 'section',
    last_edited_dt: '2026-10-13T16:00:00.000000',
    sponsor_name: 'OncoCare Therapeutics',
    sponsor_protocol_id: 'OC-2022-007',
    study_name: 'Oncology Adaptive Trial',
    sections_completed: 0,
    sections_total: 5,
  },
  // All sections complete, draft stays on the card until submitted.
];

export const PICK_UP_MOCK: PickUpYouResponse = {
  items: PICK_UP_ITEMS,
};
